<template>
  <div class="bu-form">
    <!-- d-none d-md-flex -->
    <b-navbar class="bu-form-navbar">
      <b-navbar-brand
        href="#"
        style="display: flex; align-items: center; text-transform: uppercase"
      >
        <amg-icon
          v-if="!isValidLink"
          icon="AmgIcon"
          size="40"
          class="pointer invert"
        />
        <b-img
          v-if="isValidLink"
          class="client-program mr-1"
          :src="getProgramImageRoute(1)"
          v-b-tooltip.hover.top
        />

        <span
          v-if="isValidLink"
          :class="isDarkSkin ? 'text-white' : 'text-black'"
          style="font-size: 1.2rem; font-weight: 600; text-transform: uppercase"
        >
          {{ pageTitle }}</span
        >
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto d-flex align-items-center">
          <b-nav-item href="#" class="mr-2">
            <b-form-select
              size="sm"
              v-model="selectedLanguage"
              :options="languageOptions"
              class="language-select"
            ></b-form-select>
          </b-nav-item>

          <b-nav-item href="#" class="mr-2">
            <dark-toggler class="invert" :size="'20'" />
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <template v-if="!isLoading">
      <template v-if="isValidLink">
        <template v-if="successResponse">
          <b-container>
            <div class="success-link-container">
              <div class="success-card text-center">
                <div class="icon-container">
                  <img
                    class="icon"
                    :src="
                      require(`@/assets/images/icons/business-validation-form/business_verification.png`)
                    "
                    alt="Valid Link Icon"
                  />
                </div>

                <h2 class="title">{{ t.successTitle }}</h2>

                <p class="description">
                  {{ t.successDescription }}
                </p>
              </div>
            </div>
          </b-container>
        </template>

        <template v-if="!successResponse">
          <div :class="isMobile ? 'validation-form-mobile' : 'validation-form'">
            <div class="container-welcome">
              <h4 style="font-weight: bold">
                {{ t.titleWelcome }} {{ form.c_full_name }}
              </h4>
              <p>{{ t.textWelcome }}</p>
            </div>
            <span class="title">{{ t.company_formation }}</span>

            <div v-if="form.a_company_name1" class="item">
              <span> {{ t.company_name_option1 }}:</span>
              <span>{{ form.a_company_name1 }}</span>
            </div>

            <div v-if="form.a_company_name2" class="item">
              <span> {{ t.company_name_option2 }}:</span>
              <span>{{ form.a_company_name2 }}</span>
            </div>

            <div v-if="form.a_company_type" class="items-container">
              <div class="item">
                <span> {{ t.company_type }}:</span>
                <span>{{ form.a_company_type }}</span>
              </div>

              <div v-if="form.a_purpose_naic_code" class="item">
                <span> {{ t.business_purpose_naics }}:</span>
                <span>{{ form.a_purpose_naic_code }}</span>
              </div>
            </div>

            <div v-if="form.a_type_business" class="item">
              <span> {{ t.type_of_business }}:</span>
              <span>{{ form.a_type_business }}</span>
            </div>

            <div v-if="form.a_state_formation" class="item">
              <span> {{ t.state_of_formation }}:</span>
              <span>{{ form.a_state_formation }}</span>
            </div>

            <div v-if="form.a_tax_status" class="item">
              <span> {{ t.tax_status }}:</span>
              <span>{{ form.a_tax_status }}</span>
            </div>

            <div class="items-container">
              <div v-if="form.a_operation_years" class="item">
                <span> {{ t.years_in_operation }}:</span>
                <span>{{ form.a_operation_years }}</span>
              </div>

              <div v-if="form.a_propietorship" class="item">
                <span> {{ t.existing_ein }}:</span>
                <span class="text-uppercase">{{ form.a_propietorship }}</span>
              </div>
            </div>

            <div v-if="t.principal_address" class="item">
              <span> {{ t.principal_address }}:</span>
              <span
                >{{ form.a_principal_address }} {{ form.a_principal_city }}
                {{ form.a_principal_state }} {{ form.a_principal_zip }}</span
              >
            </div>

            <div v-if="t.mailing_address" class="item">
              <span> {{ t.mailing_address }}:</span>
              <span
                >{{ form.a_mailing_address }} {{ form.a_mailing_city }}
                {{ form.a_mailing_state }} {{ form.a_mailing_zip }}</span
              >
            </div>

            <span class="title">{{ t.registered_agent_info }}</span>

            <div v-if="form.b_name" class="item">
              <span> {{ t.agent_name }}:</span>
              <span>{{ form.b_name }}</span>
            </div>

            <div class="items-container">
              <div v-if="form.b_agent_phone" class="item">
                <span> {{ t.agent_phone }}:</span>
                <span>{{ form.b_agent_phone }}</span>
              </div>

              <div v-if="form.b_agent_email" class="item">
                <span> {{ t.agent_email }}:</span>
                <span>{{ form.b_agent_email }}</span>
              </div>
            </div>

            <div v-if="form.b_agent_address" class="item">
              <span> {{ t.registered_agent_address }}:</span>
              <span
                >{{ form.b_agent_address }} {{ form.b_agent_city }}
                {{ form.b_agent_state }} {{ form.b_agent_zip }}</span
              >
            </div>

            <span class="title">{{ t.business_owner }}</span>

            <div v-if="form.c_full_name" class="item">
              <span> {{ t.full_name }}:</span>
              <span>{{ form.c_full_name }}</span>
            </div>

            <div class="items-container">
              <div v-if="form.c_phone_number" class="item">
                <span> {{ t.phone_number }}:</span>
                <span>{{ form.c_phone_number }}</span>
              </div>

              <div v-if="form.c_email" class="item">
                <span> {{ t.email }}:</span>
                <span>{{ form.c_email }}</span>
              </div>
            </div>

            <div v-if="form.c_dob" class="item">
              <span> {{ t.date_of_birth }}:</span>
              <span>{{ form.c_dob }}</span>
            </div>

            <div v-if="form.c_ssn" class="items-container">
              <div class="item">
                <span> {{ t.ssn }}:</span>
                <span>{{ form.c_ssn }}</span>
              </div>

              <div v-if="form.c_itin" class="item">
                <span> {{ t.itin }}:</span>
                <span>{{ form.c_itin }}</span>
              </div>
            </div>

            <div v-if="form.c_passport" class="item">
              <span> {{ t.passport }}:</span>
              <span>{{ form.c_passport }}</span>
            </div>

            <div v-if="form.c_principal_address" class="item">
              <span> {{ t.principal_address }}:</span>
              <span
                >{{ form.c_principal_address }} {{ form.c_principal_city }}
                {{ form.c_principal_state }} {{ form.c_principal_zip }}</span
              >
            </div>

            <div v-if="form.c_mailing_address" class="item">
              <span> {{ t.mailing_address }}:</span>
              <span
                >{{ form.c_mailing_address }} {{ form.c_mailing_city }}
                {{ form.c_mailing_state }} {{ form.c_mailing_zip }}</span
              >
            </div>

            <span class="title">{{ t.management_details }}</span>

            <div v-if="form.d_start_operation" class="item">
              <span> {{ t.start_operations_date }}:</span>
              <span>{{ form.d_start_operation }}</span>
            </div>

            <div v-if="isCorporate && form.d_managers_qty" class="item">
              <span> {{ t.number_of_managers }}:</span>
              <span>{{ form.d_managers_qty }}</span>
            </div>

            <div v-if="isCorporate && form.d_stocks" class="item">
              <span> {{ t.stocks }}:</span>
              <span>{{ form.d_stocks }}</span>
            </div>

            <div v-if="form.d_special_licenses_permits" class="item">
              <span> {{ t.special_licenses_permits }}:</span>
              <span>{{ form.d_special_licenses_permits }}</span>
            </div>

            <template
              v-if="form && form.shareholders && form.shareholders.length > 0"
            >
              <span class="title">{{ t.shareholders }}</span>
              <div
                v-for="(item, index) in form.shareholders"
                :key="index"
                class="list"
              >
                <div class="list-title">
                  {{ item.name }}
                  <span class="list-positions" v-if="getTypeLabel(item)">
                    - {{ getTypeLabel(item) }}</span
                  >
                </div>

                <div v-if="item.address" class="list-item">
                  <span> {{ t.address }}:</span>
                  <span>{{ item.address }} {{ item.zip }}</span>
                </div>
                <div v-if="item.ste_apt_fl" class="list-item">
                  <span> STE/APT/FL:</span>
                  <span>{{ item.ste_apt_fl }}</span>
                </div>
                <div v-if="item.address_continued" class="list-item">
                  <span> {{ t.address_continued }}:</span>
                  <span>{{ item.address_continued }}</span>
                </div>
              </div>
            </template>

            <template v-if="form && form.members && form.members.length > 0">
              <span class="title">{{ t.members }}</span>
              <div
                v-for="(item, index) in form.members"
                :key="index"
                class="list"
              >
                <div class="list-title">
                  {{ item.name }}
                  <span class="list-positions" v-if="getTypeLabel(item)">
                    - {{ getTypeLabel(item) }}</span
                  >
                </div>

                <div v-if="item.address" class="list-item">
                  <span> {{ t.address }}:</span>
                  <span>{{ item.address }} {{ item.zip }}</span>
                </div>
                <div v-if="item.ste_apt_fl" class="list-item">
                  <span> STE/APT/FL:</span>
                  <span>{{ item.ste_apt_fl }}</span>
                </div>
                <div v-if="item.address_continued" class="list-item">
                  <span> {{ t.address_continued }}:</span>
                  <span>{{ item.address_continued }}</span>
                </div>
              </div>
            </template>

            <div
              class="w-100 d-flex justify-content-center align-items-center text-center"
            >
              <b-form-checkbox
                id="checkbox-1"
                v-model="accepted"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
                <span
                  v-html="t.accept_text"
                  @click.stop="handleTextClick"
                ></span>
              </b-form-checkbox>
            </div>

            <div
              class="my-1 w-100 d-flex justify-content-center align-items-center"
            >
              <b-button
                :disabled="accepted === 'not_accepted'"
                variant="outline-primary"
                @click="handleOnSubmit"
                class="text-right"
                :size="isMobile ? 'sm' : 'md'"
              >
                {{ t.submit }}
                <feather-icon icon="ArrowRightIcon" size="18" class="ml-25" />
              </b-button>
            </div>
          </div>
        </template>
      </template>

      <template v-else>
        <b-container v-if="!successResponse">
          <div class="expired-link-container">
            <div class="expired-card text-center">
              <div class="icon-container">
                <img
                  class="icon"
                  :src="
                    require(`@/assets/images/icons/business-validation-form/business_verification.png`)
                  "
                  alt="Invalid Link Icon"
                />
              </div>

              <h2 class="title">{{ t.invalidLink }}</h2>

              <p class="description">
                {{ t.invalidLinkDescription }}
              </p>
            </div>
          </div>
        </b-container>
      </template>
    </template>

    <template v-else>
      <Skeleton />
    </template>

    <preview-pdf v-if="showPreviewPdf" @close="showPreviewPdf = false" />
  </div>
</template>

<script>
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import translations from "@/views/pages/business-validation-form/data/translation.js";
import BusinessValidationLinkService from "@/views/pages/business-validation-form/service/business.validation.link.js";
import Skeleton from "@/views/pages/business-validation-form/Skeleton.vue";
import PreviewPdf from "@/views/pages/business-validation-form/TermsAndConditions.vue";
export default {
  components: {
    DarkToggler,
    Skeleton,
    PreviewPdf,
  },
  data() {
    return {
      showPreviewPdf: false,
      form: {
        id: null,
        // business_company_formation (a)
        a_client_account_id: null,
        a_company_name1: null,
        a_company_name2: null,
        a_company_type: null,
        a_type_business_id: null,
        a_type_business: null,
        a_state_formation_id: null,
        a_state_formation: null,
        a_purpose_naic_code: null,
        a_tax_status_id: null,
        a_tax_status: null,
        a_principal_address: null,
        a_principal_city: null,
        a_principal_state: null,
        a_principal_zip: null,
        a_mailing_address: null,
        a_mailing_city: null,
        a_mailing_state: null,
        a_mailing_zip: null,
        a_operation_years: null,
        a_propietorship: null,
        a_created_by: null,
        a_updated_by: null,

        // registered_agent_info (b)
        b_client_account_id: null,
        b_name: null,
        b_agent_address: null,
        b_agent_city: null,
        b_agent_state: null,
        b_agent_zip: null,
        b_agent_email: null,
        b_agent_phone: null,
        b_created_by: null,
        b_updated_by: null,

        // business_owner (c)
        c_client_account_id: null,
        c_full_name: null,
        c_dob: null,
        c_ssn: null,
        c_itin: null,
        c_passport: null,
        c_phone_number: null,
        c_email: null,
        c_principal_address: null,
        c_principal_city: null,
        c_principal_state: null,
        c_principal_zip: null,
        c_mailing_address: null,
        c_mailing_city: null,
        c_mailing_state: null,
        c_mailing_zip: null,
        c_created_by: null,
        c_updated_by: null,

        // management_details (d)
        d_client_account_id: null,
        d_start_operation: null,
        d_managers_qty: null,
        d_stocks: null,
        d_special_licenses_permits: null,
        d_created_by: null,
        d_updated_by: null,

        shareholders: [],
        members: [],
      },
      accepted: "not_accepted",
      languageOptions: [
        { value: "es", text: "Español" },
        { value: "en", text: "English" },
      ],
      selectedLanguage: "en",
      isLoading: true,
      isValidLink: false,
      isMobile: window.innerWidth <= 768,
      successResponse: false,
    };
  },
  computed: {
    t() {
      return translations[this.selectedLanguage];
    },
    uniqueCode() {
      return this.$route.params.unique_code;
    },
    isCorporate() {
      return ["CORP"].includes(this.form.a_company_type);
    },
    proprietorship() {
      return [
        { text: this.t.yes, value: "Yes" },
        { text: this.t.no, value: "No" },
      ];
    },
    pageTitle() {
      return this.t.pageTitle;
    },
  },
  methods: {
    handleTextClick(event) {
      if (event.target.classList.contains("terms-link")) {
        this.previewPdf(); // tu función para abrir el PDF o modal
      }
    },
    previewPdf() {
      this.showPreviewPdf = true;
    },
    getTypeLabel(item) {
      if (item.type === "DIRECTOR") {
        return "DIRECTOR";
      } else if (item.type === "OFFICER") {
        return item.positions || null;
      } else {
        return null;
      }
    },
    async handleOnSubmit() {
      try {
        this.addPreloader();

        let payload = {
          id: this.form.id,
          status: "COMPLETED",
        };

        const { data } = await BusinessValidationLinkService.update(payload);
        const message = data.message;

        if (message === "Link updated successfully") {
          this.successResponse = true;
        } else {
          showErrorSwal(JSON.stringify(data), "Error");
        }
      } catch (error) {
        let message_error = error.response.data.message;

        if (!message_error) {
          this.showErrorSwal(error);
          return;
        }

        let type;

        if (message_error === "Current link is invalid") {
          type = "invalid";
        } else {
          type = "generalError";
        }
        const { title, description } = this.t.errorMessage[type];
        this.showErrorSwal(description, title);
      } finally {
        this.removePreloader();
      }
    },
    async checkIfIsValidLink() {
      try {
        this.isLoading = true;

        const { data } = await BusinessValidationLinkService.isValidLink(
          this.uniqueCode
        );

        this.isValidLink = data.valid;

        if (!this.isValidLink) {
          this.isLoading = false;
        }

        document.title = this.pageTitle;
      } catch (error) {
        const { title, description } = this.t.errorMessage.generalError;
        this.showErrorSwal(description, title);
      }
    },
    async getLinkData() {
      try {
        const { data } = await BusinessValidationLinkService.getLinkData(
          this.uniqueCode
        );
        this.form = data;
      } catch (error) {
        const { title, description } = this.t.errorMessage.generalError;
        this.showErrorSwal(description, title);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.checkIfIsValidLink();
  },
  watch: {
    isValidLink(newValue) {
      if (newValue !== null && newValue === true) {
        this.getLinkData();
      }
    },
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

.bu-form {
  font-family: "Montserrat", sans-serif !important;

  .validation-form-skeleton {
    margin-top: 5rem;
    padding: 0 1rem;
  }

  &-navbar {
    background-color: #fff;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  }
  .language-select {
    width: auto;
    height: 35px;
    font-size: 1rem;
  }

  .bu-form-navbar .b-navbar-nav {
    display: flex;
    align-items: center;
  }

  .bu-form-navbar .b-nav-item {
    display: flex;
    align-items: center;
  }

  .bu-form-navbar .b-navbar-brand,
  .bu-form-navbar .b-navbar-toggle {
    display: flex;
    align-items: center;
  }

  .success-link-container {
    max-width: 90vw;
    margin: 3rem auto 0;
    padding: 1.25rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Montserrat", sans-serif !important;

    .success-card {
      max-width: calc(100% - 40px);
      padding: 1.5rem 0;
      text-align: center;
    }

    .icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 15px;
    }

    .icon {
      max-width: 15vw;
    }

    .title {
      margin: 2rem 0 1rem;
      font-size: clamp(1.6rem, 5vw, 2.5rem);
      font-weight: 700;
      color: #0090e7;
    }

    .description {
      font-size: clamp(1.2rem, 4vw, 1.5rem);
      color: #6e6e6e;
      margin-bottom: 2rem;
      font-weight: 700;
    }
  }

  .expired-link-container {
    max-width: 90vw;
    margin: 3rem auto 0;
    padding: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Montserrat", sans-serif !important;

    .expired-card {
      max-width: calc(100% - 40px);
      padding: 1.5rem;
      text-align: center;
    }

    .icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 15px;
    }

    .icon {
      max-width: 15vw;
    }

    .title {
      margin: 2rem 0 1rem;
      font-size: clamp(1.6rem, 5vw, 2.5rem);
      font-weight: 700;
      color: #0090e7;
    }

    .description {
      font-size: clamp(1.2rem, 4vw, 1.5rem);
      color: #6e6e6e;
      margin-bottom: 2rem;
      font-weight: 700;
    }
  }

  .validation-form {
    padding: 1.5rem;
    display: flex;
    flex-wrap: wrap;

    .terms-link {
      font-weight: bold;
      color: #007bff;
      cursor: pointer;
      text-decoration: underline;
    }

    .title {
      font-size: 1.5rem;
      font-weight: bolder;
      padding: 0rem;
      margin: 0 0 1rem 0rem;
      width: 100%;
      color: #fbbb04;
      border-bottom: 1px solid #fbbb04;
    }

    .list {
      display: inline-block;
      width: 100%;
      justify-content: start;
      align-items: center;
      margin: 0 0 1rem 0rem;

      .list-title {
        font-weight: 700;
        border-bottom: 1px solid #dddddd;
        margin-bottom: 0.5rem;

        .list-positions {
          font-weight: 600;
        }
      }

      .list-item {
        display: flex;
        justify-content: start;
        align-items: center;
        width: 100%;
        margin: 0 0 1rem 0rem;

        // first span
        span:first-child {
          font-weight: bold;
          min-width: 20vw !important;
        }

        // second span
        // span:last-child {
        // margin-left: 0.5rem;
        // }
      }
    }

    .items-container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .item {
        margin: 0;
        display: flex;
        justify-content: start;
        align-items: center;
        width: auto;
        min-width: 50%;
        padding: 0 0 1rem 0rem;
      }
    }

    .item {
      display: flex;
      justify-content: start;
      align-items: center;
      width: 100%;
      margin: 0 0 1rem 0rem;

      // first span
      span:first-child {
        font-weight: bold;
        min-width: 20vw !important;
      }

      // second span
      // span:last-child {
      // margin-left: 0.5rem;
      // }
    }
  }

  // @media (min-width: 576px) {
  //   .validation-form {
  //     padding: 1rem 5rem !important;
  //   }
  // }

  @media (min-width: 1200px) {
    .validation-form {
      padding: 1rem 20rem !important;
    }
  }

  .validation-form-mobile {
    padding: 1.5rem 1rem;
    display: flex;
    flex-wrap: wrap;

    .title {
      font-size: clamp(0.8rem, 2vw + 1rem, 1.3rem);
      font-weight: bolder;
      padding: 0rem;
      margin: 0 0 0.5rem 0rem;
      width: 100%;
      color: #fbbb04;
      border-bottom: 1px solid #fbbb04;
    }

    .list {
      display: inline-block;
      width: 100%;
      justify-content: center;
      align-items: start;
      margin: 0 0 1rem 0rem;
      flex-direction: column;

      .list-title {
        font-weight: 700;
        border-bottom: 1px solid #dddddd;
        margin-bottom: 0.5rem;

        .list-positions {
          font-weight: 600;
        }
      }

      .list-item {
        display: flex;
        justify-content: center;
        align-items: start;
        width: 100%;
        margin: 0 0 1rem 0rem;
        flex-direction: column;

        // first span
        span:first-child {
          font-weight: bold;
          min-width: 40vw !important;
        }

        // second span
        // span:last-child {
        // margin-left: 0.5rem;
        // }
      }
    }

    .items-container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .item {
        margin: 0;
        display: flex;
        justify-content: start;
        align-items: start;
        flex-direction: column;
        width: auto;
        min-width: 50%;
        padding: 0 0 1rem 0rem;
      }
    }

    .item {
      display: flex;
      justify-content: center;
      align-items: start;
      width: 100%;
      flex-direction: column;
      margin: 0 0 1rem 0rem;

      // first span
      span:first-child {
        font-weight: bold;
        min-width: 20vw !important;
      }

      // second span
      // span:last-child {
      //   margin-left: 0.5rem;
      // }
    }
  }
}

.dark-layout {
  .bu-form {
    &-navbar {
      background-color: #17171a !important;
    }

    .invert {
      filter: invert(100%);
    }
  }
}
</style>
